import React, { useState, useEffect } from 'react';
import {
  Row, Col, Card, CardBody, Button, Alert, Collapse, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import axios from 'axios';
import { removePhoto } from '../api/photoApi';

export function NewPhotos() {
  const [photos,        setPhotos]        = useState([]);
  const [grouped,       setGrouped]       = useState({});
  const [expanded,      setExpanded]      = useState({});
  const [currentPhoto,  setCurrentPhoto]  = useState(null);

  const [manufacturer,  setManufacturer]  = useState('');
  const [shingleType,   setShingleType]   = useState('');
  const [color,         setColor]         = useState('');

  const [rotation,      setRotation]      = useState(0);
  const [showSuccess,   setShowSuccess]   = useState(false);

  const [sortConfig,    setSortConfig]    = useState({ key: 'name', direction: 'asc' });

  // Deletion confirmation
  const [confirmOpen,   setConfirmOpen]   = useState(false);

  // Dynamic‑dropdown state
  const [manufacturers,  setManufacturers]   = useState([]);
  const [products,       setProducts]        = useState([]);
  const [availableColors,setAvailableColors]= useState([]);

  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    loadPhotos();
    loadManufacturers();
  }, []);

  /* ---------------- Helpers ---------------- */
  async function loadPhotos() {
    try {
      const token = localStorage.getItem('idToken');
      const res   = await axios.get('http://localhost:8001/api/photos/unlabeled', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPhotos(res.data);
      const grp = res.data.reduce((acc, p) => {
        const f = p.folder || 'Uncategorized';
        (acc[f] = acc[f] || []).push(p);
        return acc;
      }, {});
      setGrouped(grp);
    } catch (err) { console.error(err); }
  }

  async function loadManufacturers() {
    try {
      const res = await axios.get('http://localhost:8001/api/shingles/manufacturers');
      setManufacturers(res.data.manufacturers);
    } catch (err) { console.error(err); }
  }

  async function loadProducts(manuf, pre = null) {
    if (!manuf) return;
    try {
      const res = await axios.get('http://localhost:8001/api/shingles/products', {
        params: { manufacturer: manuf },
      });
      let list = res.data.products;
      if (pre && !list.includes(pre)) list = [pre, ...list];
      setProducts(list);
    } catch (err) { console.error(err); }
  }

  async function loadColors(prod, pre = null) {
    if (!prod) { setAvailableColors([]); return; }
    try {
      const res = await axios.get('http://localhost:8001/api/shingles/colors', {
        params: { manufacturer, product: prod },
      });
      let list = res.data.colors;
      if (pre && !list.includes(pre)) list = [pre, ...list];
      setAvailableColors(list);
    } catch (err) { console.error(err); }
  }

  /* --------------- ROTATION --------------- */
  const rotateLeft  = () => setRotation((p) => (p + 270) % 360);
  const rotateRight = () => setRotation((p) => (p + 90)  % 360);

  /* --------------- FOLDER UTILS --------------- */
  const toggleFolder = (f) => setExpanded((pr) => ({ ...pr, [f]: !pr[f] }));

  async function handleFolderApprove(folder) {
    if (!manufacturer || !shingleType || !color) {
      alert('Select manufacturer, product, and color first');
      return;
    }
    try {
      const token = localStorage.getItem('idToken');
      await axios.post(
        `http://localhost:8001/api/photos/folders/${folder}/label`,
        {
          username:      localStorage.getItem('username'),
          label:         'Label',
          manufacturer,
          shingle_type:  shingleType,
          color,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setShowSuccess(true);
      setTimeout(() => { setShowSuccess(false); loadPhotos(); }, 2000);
    } catch (err) { console.error(err); }
  }

  /* --------------- PHOTO SELECT --------------- */
  async function handlePhotoClick(p) {
    setCurrentPhoto(p);
    setRotation(p.orientation || 0);
    setManufacturer(p.manufacturer || '');
    await loadProducts(p.manufacturer, p.shingle_type);
    setShingleType(p.shingle_type || '');
    await loadColors(p.shingle_type, p.color);
    setColor(p.color || '');
  }

  /* --------------- SAVE LABEL --------------- */
  async function handleLabelPhoto() {
    if (!currentPhoto) return;
    try {
      const token = localStorage.getItem('idToken');
      await axios.post(
        `http://localhost:8001/api/photos/${currentPhoto.id}/label`,
        {
          username:       localStorage.getItem('username'),
          label:          'Label',
          manufacturer,
          shingle_type:   shingleType,
          color,
          orientation:    rotation,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setShowSuccess(true);
      setTimeout(() => {
        resetState();
        loadPhotos();
      }, 1500);
    } catch (err) { console.error(err); }
  }

  /* --------------- DELETE (soft) --------------- */
  const confirmDelete = () => setConfirmOpen(true);

  async function handleDelete() {
    try {
      await removePhoto(currentPhoto.id);
      setConfirmOpen(false);
      resetState();
      loadPhotos();
    } catch (err) {
      console.error(err);
      setConfirmOpen(false);
      alert('Delete failed.');
    }
  }

  const resetState = () => {
    setCurrentPhoto(null);
    setRotation(0);
    setManufacturer(''); setShingleType(''); setColor('');
    setProducts([]);     setAvailableColors([]);
  };

  /* --------------- SORTING --------------- */
  const handleSort = (key) => {
    setSortConfig((pr) => ({
      key,
      direction: pr.key === key && pr.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortedPhotos = [...photos].sort((a, b) => {
    const { key, direction } = sortConfig;
    const ord = direction === 'asc' ? 1 : -1;
    return a[key] < b[key] ? -1 * ord : a[key] > b[key] ? 1 * ord : 0;
  });

  /* ================= RENDER ================ */
  return (
    <div className="page-content">
      <Row>
        <Col xs={12}><h4>New Photos by Folder</h4></Col>
      </Row>

      {showSuccess && <Alert color="success">Operation successful</Alert>}

      <Row>
        {/* ------------ LEFT – FOLDERS ------------ */}
        <Col md={currentPhoto ? 5 : 12}>
          {Object.entries(grouped).map(([folder, list]) => (
            <Card key={folder} className="mb-3">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h5 style={{ cursor: 'pointer' }} onClick={() => toggleFolder(folder)}>
                    {folder} ({list.length})
                  </h5>
                  <Button color="success" onClick={() => handleFolderApprove(folder)}>
                    Approve Folder
                  </Button>
                </div>

                <Collapse isOpen={expanded[folder]}>
                  <div className="mt-2 mb-3">
                    {list.map((p) => (
                      <img
                        key={p.id}
                        src={p.url}
                        alt={p.name}
                        className="img-thumbnail me-2 mb-2"
                        style={{ width: '100px', cursor: 'pointer' }}
                        onClick={() => handlePhotoClick(p)}
                      />
                    ))}
                  </div>
                </Collapse>

                {/* simple table */}
                <div>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                          Photo Name&nbsp;
                          {sortConfig.key === 'name' && (
                            sortConfig.direction === 'asc'
                              ? <i className="mdi mdi-chevron-up" />
                              : <i className="mdi mdi-chevron-down" />
                          )}
                        </th>
                        <th onClick={() => handleSort('upload_timestamp')} style={{ cursor: 'pointer' }}>
                          Upload Date&nbsp;
                          {sortConfig.key === 'upload_timestamp' && (
                            sortConfig.direction === 'asc'
                              ? <i className="mdi mdi-chevron-up" />
                              : <i className="mdi mdi-chevron-down" />
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedPhotos
                        .filter((p) => (p.folder || 'Uncategorized') === folder)
                        .map((photo) => (
                          <tr key={photo.id} onClick={() => handlePhotoClick(photo)} style={{ cursor: 'pointer' }}>
                            <td>{photo.name}</td>
                            <td>{new Date(photo.upload_timestamp).toLocaleString()}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          ))}
        </Col>

        {/* ------------ RIGHT – SINGLE PHOTO ------------ */}
        {currentPhoto && (
          <Col md={7}>
            <Card>
              <CardBody>
                {/* image + rotation */}
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <Button color="secondary" className="me-2" onClick={rotateLeft}>
                    <i className="mdi mdi-rotate-left" />
                  </Button>
                  <img
                    src={currentPhoto.url}
                    alt={currentPhoto.name}
                    className="img-fluid"
                    style={{ transform: `rotate(${rotation}deg)`, transition: 'transform 0.25s', maxHeight: '60vh' }}
                  />
                  <Button color="secondary" className="ms-2" onClick={rotateRight}>
                    <i className="mdi mdi-rotate-right" />
                  </Button>
                </div>

                {/* dropdowns */}
                <select
                  className="form-select mb-2"
                  value={manufacturer}
                  onChange={(e) => {
                    setManufacturer(e.target.value);
                    setShingleType(''); setColor('');
                    loadProducts(e.target.value);
                  }}
                >
                  <option value="" disabled>Manufacturer</option>
                  {manufacturers.map((m, i) => <option key={i} value={m}>{m}</option>)}
                </select>

                <select
                  className="form-select mb-2"
                  value={shingleType}
                  onChange={(e) => {
                    setShingleType(e.target.value);
                    setColor('');
                    loadColors(e.target.value);
                  }}
                >
                  <option value="" disabled>Product</option>
                  {products.map((p, i) => <option key={i} value={p}>{p}</option>)}
                </select>

                <select
                  className="form-select mb-3"
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                >
                  <option value="" disabled>Color</option>
                  {availableColors.map((c, i) => <option key={i} value={c}>{c}</option>)}
                </select>

                {/* action buttons (swapped order) */}
                <div className="d-flex justify-content-between">
                  <Button color="primary" onClick={handleLabelPhoto}>
                    Submit Label &amp; Orientation
                  </Button>

                  <Button color="danger" onClick={confirmDelete}>
                    Delete Photo
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>

      {/* Confirm Modal */}
      <Modal isOpen={confirmOpen} toggle={() => setConfirmOpen(false)}>
        <ModalHeader toggle={() => setConfirmOpen(false)}>Confirm Deletion</ModalHeader>
        <ModalBody>
          Are you sure you want to remove <strong>{currentPhoto?.name}</strong>?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button color="danger" onClick={handleDelete}>Yes, Remove</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default NewPhotos;

